import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Check"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-check',
    templateUrl: './icon-cash-check.component.html',
    styleUrls: ['./icon-cash-check.component.scss'],
    standalone: false
})
export class IconCashCheckComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
